import React from 'react';

/**
 * Modal wrapper for consistent overlays
 * Props: open, onClose, children, className
 */
export default function Modal({ open, onClose, children, className = '' }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm">
      <div className={`relative bg-gray-800 bg-opacity-60 rounded-2xl shadow-2xl p-6 min-w-[320px] max-w-full mx-2 ${className}`}>
        {onClose && (
          <button
            className="absolute top-2 right-2 text-gray-400 hover:text-white text-2xl font-bold z-10 bg-gray-900 bg-opacity-80 rounded-full w-8 h-8 flex items-center justify-center shadow-lg"
            onClick={e => {
              e.stopPropagation();
              onClose();
            }}
            aria-label="Close"
            type="button"
          >
            ×
          </button>
        )}
        {children}
      </div>
    </div>
  );
}
